// src/components/Footer.js - Simple Version
import React from 'react';
import { WEDDING_CONFIG } from '../config';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <p style={styles.copyright}>Crizza & Jerwin</p>
        <p style={styles.support}>
         ©Joseph Renor Obrino
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    color: 'white',
    padding: '2rem',
    textAlign: 'center',
    marginTop: 'auto',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  copyright: {
    fontSize: '1.2rem',
    fontWeight: '600',
    margin: '0 0 0.5rem 0',
    fontFamily: "'Playfair Display', serif",
  },
  support: {
    fontSize: '0.9rem',
    margin: 0,
    opacity: 0.9,
  },
};

export default Footer;